import React from 'react';
import Box from 'components/react-styled-core/Box';

const Header = ({ children }) => (
    <Box
        boxSizing="border-box"
        borderTop="4px solid"
        borderTopColor="red:80"
        height="60px"
        borderBottom="1px solid"
        borderBottomColor="gray:60"
        bg="white"
    >
        {children}
    </Box>
);

export default Header;
